import { Injectable } from '@angular/core';
import { Erreur, Nomenclature, NomenclatureErreurValidation, ObjetMaquetteSummary } from '@pcscol/odf-api-v1-angular';

@Injectable({
    providedIn: 'root'
})
export class DownloadService {
    constructor() {}

    private downloadBlob(blob: Blob, filename: string): void {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    public downloadCSVFromBlob(blob: Blob, filename: string) {
        const blobToDownload = new Blob([blob], { type: 'text/csv;charset=utf-8;' });
        this.downloadBlob(blobToDownload, filename);
    }

    downloadExportEnMasseResultatsCSV(
        exportEnMasseResponse: { om: ObjetMaquetteSummary; erreur?: string }[],
        codeEspaceOrigine: string,
        codeEspaceDestination: string
    ) {
        const date = new Date();
        const fileName = `resultats-import-${date.toLocaleDateString()}-de_${codeEspaceOrigine}-vers${codeEspaceDestination}`;
        const blob: Blob = new Blob([this.convertExportEnMasseResponseToCsv(exportEnMasseResponse)], { type: 'text/csv;charset=utf-8;' });
        this.downloadBlob(blob, fileName);
    }

    private convertExportEnMasseResponseToCsv(exportEnMasseResponse: { om: ObjetMaquetteSummary; erreur?: string }[]): string {
        const headers = ['code', 'libelle', 'résultat', 'erreurs'];
        let str = '';
        for (const index in headers) {
            str += headers[index] + ',';
        }
        str += '\r\n';
        exportEnMasseResponse.forEach(v => {
            str += `${v.om.code},${v.om.libelle},${v.erreur ? 'échec' : 'succès'},${v.erreur ?? ''}\r\n`;
        });
        return str;
    }

    downloadErreursNomenclaturesAsCSV(erreursNomenclatures: NomenclatureErreurValidation[], codeRacine: string, codeEspace: string) {
        const date = new Date();
        const fileName = `erreurs-nomenclatures-${codeRacine}-${codeEspace}-${date.toLocaleDateString()}`;
        const blob: Blob = new Blob([this.convertErreursNomenclaturesResponseToCsv(erreursNomenclatures)], {
            type: 'text/csv;charset=utf-8;'
        });
        this.downloadBlob(blob, fileName);
    }

    private convertErreursNomenclaturesResponseToCsv(erreursNomenclatures: NomenclatureErreurValidation[]): string {
        const headers = ['id', 'code objet maquette', 'type nomenclature', 'code nomenclature'];
        let str = '';
        for (const index in headers) {
            str += headers[index] + ',';
        }
        str += '\r\n';
        erreursNomenclatures.forEach((e: NomenclatureErreurValidation) => {
            e.nomenclatureList.forEach((n: Nomenclature) => {
                str += `${e.id},${e.codeObjetMaquette},${n.type},${n.code}\r\n`;
            });
        });
        return str;
    }

    downloadCopieDiplomeVersEspaceResultatsCSV(erreurs: Erreur[]) {
        const date = new Date();
        const fileName = `resultats-copie-diplomes-${date.toLocaleDateString()}`;
        const blob: Blob = new Blob([this.convertCopieDiplomeVersEspaceResponseToCsv(erreurs)], { type: 'text/csv;charset=utf-8;' });
        this.downloadBlob(blob, fileName);
    }

    private convertCopieDiplomeVersEspaceResponseToCsv(erreurs: Erreur[]): string {
        const headers = ['code', 'message'];
        let str = '';
        for (const index in headers) {
            str += headers[index] + ',';
        }
        str += '\r\n';
        erreurs.forEach(v => {
            str += `${v.code},${v.message}\r\n`;
        });
        return str;
    }
}
